import React from 'react'

class Contact extends React.Component {
  render () {
    return (
      <div className="row">
        <div className="col-md-8 col-md-offset-2">
          <div className="lead text-center">
            <br/>
            <p>Questions or comments? Shoot me an email -- <a href="mailto:nate@fantasymath.com">nate@fantasymath.com</a></p>
          </div>
        </div>
      </div>
    )
  }
}

export default Contact





// WEBPACK FOOTER //
// ./src/components/Contact.js